export class BusinessTransactionItemKey {
    public id: number;
    public businessTransactionItemKeyTypeId: number;
    public businessTransactionNumberId: number;
    public itemKeyId: number;

    constructor(itemKeyId: number = undefined, businessTransactionItemKeyTypeId: number = undefined) {
        this.itemKeyId = itemKeyId;
        this.businessTransactionItemKeyTypeId = businessTransactionItemKeyTypeId;
    }
}
